import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import {
  listarOportunidadesSeller,
  listarOportunidadesPorFiltroSeller,
  gerarExelOportunidadesSeller,
} from "../../../services/http/oportunidadeService";

import services from "../../../services";

import { trackPromise } from "react-promise-tracker";
import { useSnackBar } from "../../../hooks/snackBar";
import ListOportunidade from "./ListOportunidade";
import { saveAs } from "file-saver";

import "./styles.scss";

const PerfilSellerOportunidade = () => {
  const history = useHistory();
  const { idSeller } = services.storage.getUser();
  const { addSnackBar } = useSnackBar();
  const [busca, setBusca] = useState("");
  const [oportunidades, setOportunidades] = useState({
    numeroPagina: 0,
    totalPaginas: 0,
    lista: [],
    tamanhoPagina: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const carregarListaOportunidades = (pagina) => {
    trackPromise(
      listarOportunidadesSeller(idSeller, pagina).then((res) => {
        if (res.data) {
          setOportunidades(res.data);
        }
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const CarregarListaOportunidadesComFiltro = (filtro, pagina) => {
    trackPromise(
      listarOportunidadesPorFiltroSeller(idSeller, filtro, pagina).then(
        (res) => {
          if (res.data) {
            setOportunidades(res.data);
          }
        }
      )
    ).catch((error) => {
      console.log(error);
    });
  };

  const extrairBase = () => {
    trackPromise(
      gerarExelOportunidadesSeller(idSeller).then((res) => {
        if (res.data) {
          saveAs(res.data, "Oportunidades.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível extrair a base de oportunidades",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano extrair a base de oportunidades",
        info: "error",
        open: true,
      });
    });
  };

  const mudarPaginaOportunidade = (page) => {
    busca != ""
      ? CarregarListaOportunidadesComFiltro(busca, page)
      : carregarListaOportunidades(page);
  };

  const buscar = (filtro) => {
    setBusca(filtro);
  };

  useEffect(() => {
    if (busca != "") {
      const delayDebounceFn = setTimeout(() => {
        CarregarListaOportunidadesComFiltro(busca, 1);
      }, 2000);

      return () => clearTimeout(delayDebounceFn);
    } else {
      carregarListaOportunidades(1);
    }
  }, [busca]);

  useEffect(() => {
    carregarListaOportunidades(1);
  }, []);

  return (
    <div>
      <div className="row mt20">
        <h1 className="col-sm-12 col-md-12 col-lg-12 titulo">Oportunidades</h1>
      </div>

      <div className="row mt20">
        <h1 className="col-sm-12 col-md-12 col-lg-12 label-second">
          Histórico de Oportunidades
        </h1>
      </div>

      <div className="row">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <button
            onClick={() => history.push("/seller/oportunidade/cadastro")}
            className="buton-green btn btn-block btn-lg mt20"
          >
            CADASTRAR OPORTUNIDADE
          </button>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3">
          <button
            className="buton-white-black-border btn btn-block btn-lg mt20"
            onClick={extrairBase}
          >
            EXTRAIR BASE DE OPORTUNIDADES
          </button>
        </div>
      </div>
      <ListOportunidade
        response={oportunidades}
        mudarPagina={mudarPaginaOportunidade}
        buscar={buscar}
        busca={busca}
      />
    </div>
  );
};

export default PerfilSellerOportunidade;
